export const normalizeEtsyMatchingSourceKey = (value: string): string => value
  .trim()
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, ' ')
  .trim()
  .replace(/\s+/g, ' ');

export const buildEtsyVariationNameKey = (variationName: string): string => {
  return normalizeEtsyMatchingSourceKey(variationName);
};

export const buildEtsyVariationMappingKey = (variationName: string, variationValue: string): string => {
  return `${buildEtsyVariationNameKey(variationName)}::${normalizeEtsyMatchingSourceKey(variationValue)}`;
};
